// Generated by CoffeeScript 1.4.0
(function() {

  $(function() {
    var $all_charities, $all_suggest_boxes, $branch_1, $branch_2, $branch_3, $branch_4, $branches, $charity_sponsor, $create_customer_form, $dashboard_charity_chooser, $dashboard_header, $dashboard_single_charity_header, $dashboard_single_charity_info, $dashboard_single_charity_view, $donate_amount, $hiw_header_p, $hiw_section_choose, $hiw_sections, $hiw_slider, $hiw_slider_holder, $how_it_works_page_header_text, $nickle, $page_privacy_policies_modal_close, $page_terms_agreement_modal_close, $pear, $privacy_policies, $section_contents, $share_story, $share_story_button, $sign_up_modal, $single_donate_goal_meter, $suggest_box, $suggest_charity_button, $terms_agreement, $update_family_form, $vote_content, add_family_member_to_select, add_giving_history_line, adjust_child_form_ids, adjust_goal_meter, adjust_hiw_arrows, bird_wing_flap, birthday_length_check, branch1_enter, branch1_offset, branch1_offset_top, branch2_enter, branch2_offset, branch2_offset_top, branch3_enter, branch3_offset, branch3_offset_top, branch4_enter, branch4_offset, branch4_offset_top, branches_offset, branches_offset_top, charities_categories_html, charities_for_voting, charities_html_list, charity_for_category, charity_showing, children_array, children_to_remove, coin_donation, coin_donation_big, coin_drop, current_customer_json, current_family_id, current_home_page_section, current_selected_charity, current_x, current_x_tip, current_x_tip_offset, customer_url_json, dashboard_show_charity, date_fixer, dd, donate_to_charity, family_ajax_data, flap_interval, form_url, get_charity_category_json, goToByScroll, go_current_goal_percent, go_section_3, go_section_4, header_holder_offset, header_menu_top, home_page_sections, is_iPad, is_mobile, json_data_charities, json_data_voting, learn_more_section_length, learn_more_section_switch, mm, modal_top, mouse_x, nickle_fall, number_of_children, pear_drop, pear_right, preloaded_images, section_content_width, section_number, set_x, show_credits_dashboard, show_family_member_switcher, sign_up_modal_left, slide_bounders, slide_branch, slide_x, slided_section_width, sliding, stop_flap, stop_slide, suggest_box_left, today, up_or_down, update_giving_history, update_section_selected, update_slide, update_user_dashboard, value_count, voting_charities_html, x_difference, yyyy,
      _this = this;
    is_mobile = false;
    if ($(window).width() <= 480 && $(window).width() >= 320) {
      is_mobile = true;
    }
    is_iPad = navigator.userAgent.match(/iPad/i) !== null;
    $('[placeholder]').focus(function() {
      var input;
      input = $(this);
      if (input.val() === input.attr('placeholder')) {
        input.val('');
        return input.removeClass('placeholder');
      }
    }).blur(function() {
      var input;
      input = $(this);
      if (input.val() === '' || input.val() === input.attr('placeholder')) {
        input.addClass('placeholder');
        return input.val(input.attr('placeholder'));
      }
    }).blur();
    if (is_mobile === false || is_iPad === false) {
      $('.home_container > section').css({
        'min-height': $(window).height()
      });
      $('.home_container > #dashboard_nav').css({
        'min-height': 40
      });
      $('.home_container > #dashboard_header').css({
        'min-height': 97
      });
    }
    $('.single_suggested_product:last-child').css('margin-right', 0);
    $('.video_ctas .cta:last-child').css({
      'margin-right': 0
    });
    $(window).resize(function() {
      var pear_right;
      if (!!$pear) {
        pear_right = $(window).width() / 2 - 260;
        $pear.css({
          right: pear_right
        }).rotate(-20);
      }
      adjust_hiw_arrows();
      return $sign_up_modal.css({
        left: ($(window).width() / 2) - ($sign_up_modal.outerWidth(true) / 2)
      });
    });
    up_or_down = 'up';
    bird_wing_flap = function() {
      if (up_or_down === 'up') {
        up_or_down = 'down';
        $('.left_bird').css({
          'background-position': '-50px -51px'
        });
        return $('.right_bird').css({
          'background-position': '0 0'
        });
      } else {
        up_or_down = 'up';
        $('.left_bird').css({
          'background-position': '0px -51px'
        });
        return $('.right_bird').css({
          'background-position': '-50px 0px'
        });
      }
    };
    flap_interval = setInterval(bird_wing_flap, 100);
    stop_flap = function() {
      return clearInterval(flap_interval);
    };
    _.each($('#main_nav a'), function(key, value) {
      if ($(key).attr('href') === window.location.pathname) {
        return $(key).addClass('active');
      }
    });
    _.each($('#dashboard_nav a'), function(key, value) {
      if ($(key).attr('href') === window.location.pathname) {
        return $(key).addClass('active');
      }
    });
    if (is_mobile === true) {
      $('#main_nav').slideUp();
      $('#mobile_nav_drop').toggle(function() {
        return $('#main_nav').slideDown();
      }, function() {
        return $('#main_nav').slideUp();
      });
    }
    if (is_mobile === false) {
      $('.inactive').hover(function() {
        var this_offset, this_offset_left, this_outer_width;
        this_offset = $(this).offset();
        this_outer_width = $(this).parent().outerWidth(true);
        this_offset_left = this_offset.left - (($(window).width() / 2) - ($('.header_holder').width() / 2) + 22);
        $('.coming_soon').css({
          left: this_offset_left,
          width: this_outer_width
        });
        return $('.coming_soon').stop(true, true).animate({
          opacity: 1
        });
      }, function() {
        return $('.coming_soon').stop(true, true).animate({
          opacity: 0
        });
      });
    }
    home_page_sections = new Array;
    current_home_page_section = new Number;
    value_count = -1;
    _.each($('.home_container > section'), function(key, value) {
      if ($(key).attr('id') !== "dashboard_nav") {
        if ($(key).attr('id') !== "dashboard_header") {
          value_count++;
          return home_page_sections[value_count] = $(key).attr('id');
        }
      }
    });
    if ('/' === window.location.pathname) {
      $(this).keydown(function(e) {
        if (e.keyCode === 38) {
          current_home_page_section--;
          goToByScroll();
          false;
        }
        if (e.keyCode === 40) {
          current_home_page_section++;
          goToByScroll();
          return false;
        }
      });
    }
    $('#go_to_section .section_up').click(function() {
      current_home_page_section--;
      return goToByScroll();
    });
    $('#go_to_section .section_down').click(function() {
      current_home_page_section++;
      return goToByScroll();
    });
    /*
      # home modal once
      $home_modal_coming_soon = $('#home_modal_coming_soon').css {display: 'none', opactiy: 0}
      
      if is_mobile is no or is_iPad is no
        #check and set cookie
        if $.cookie("visited") is 'yes'
          $home_modal_coming_soon.remove()
        else if $.cookie('visited') is null
          $.cookie("visited","yes")
          $home_modal_coming_soon.css('display','block').animate {opacity: 1}
        #close modal
        $('#home_modal_coming_soon .modal_close, #home_modal_coming_soon .click_sign_up, #home_modal_coming_soon .continue ').click () ->
          $home_modal_coming_soon.animate {opacity: 0}, {duration: 400, complete: () ->
            $home_modal_coming_soon.remove()
          }
    */

    goToByScroll = function() {
      var id, offset_top_for_section;
      if (current_home_page_section > value_count) {
        current_home_page_section = 0;
      }
      if (current_home_page_section < 0) {
        current_home_page_section = value_count;
      }
      id = home_page_sections[current_home_page_section];
      offset_top_for_section = $("#" + id).offset().top - 50;
      if (current_home_page_section === 0) {
        offset_top_for_section = 0;
      }
      if (current_home_page_section === $('.home_container > section').length - 1) {
        offset_top_for_section = $("#" + id).offset().top - 70;
      }
      if (is_mobile === true) {
        offset_top_for_section = $("#" + id).offset().top;
        if (current_home_page_section === 0) {
          offset_top_for_section = 0;
        }
      }
      return $('html,body').animate({
        scrollTop: offset_top_for_section
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
    };
    pear_right = $(window).width() / 2 - 260;
    $pear = $('#pear');
    pear_drop = function() {
      $pear.stop(true, true).animate({
        top: 232,
        rotate: -90
      }, {
        duration: 900,
        easing: 'easeOutBounce'
      });
      return $pear.delay(2000).rotate({
        angle: -20,
        animateTo: -100,
        duration: 1100,
        easing: $.easing.easeOutQuad
      });
    };
    if (!!$pear) {
      $pear.css({
        right: pear_right,
        top: 132
      }).rotate(-20);
      setTimeout(pear_drop, 2000);
    }
    header_holder_offset = $('.header_holder ul').offset();
    if (is_mobile === false || is_iPad === false) {
      header_menu_top = header_holder_offset.top - 16;
    }
    $branches = $('#branches');
    branches_offset = $branches.offset();
    if (!!branches_offset) {
      branches_offset_top = branches_offset.top;
      $branch_1 = $branches.find('#branch_1');
      branch1_offset = $branch_1.offset();
      branch1_offset_top = branch1_offset.top;
      branch1_enter = branch1_offset_top - $(window).height();
      $branch_2 = $branches.find('#branch_2');
      branch2_offset = $branch_2.offset();
      branch2_offset_top = branch2_offset.top;
      branch2_enter = branch2_offset_top - $(window).height();
      $branch_3 = $branches.find('#branch_3');
      branch3_offset = $branch_3.offset();
      branch3_offset_top = branch3_offset.top;
      branch3_enter = branch3_offset_top - $(window).height();
      $branch_4 = $branches.find('#branch_4');
      branch4_offset = $branch_4.offset();
      branch4_offset_top = branch4_offset.top;
      branch4_enter = branch4_offset_top - $(window).height();
    }
    if (is_mobile === true) {
      $('.branch_tooltip').css({
        left: $(window).width() / 2 - 150
      });
    }
    $(this).scroll(function() {
      var current_top, header_top_set, scroll_diff_branch_1, scroll_diff_branch_2, scroll_diff_branch_3, scroll_diff_branch_4;
      current_top = $(_this).scrollTop();
      if (is_mobile === false && is_iPad === false) {
        if (current_top >= header_menu_top) {
          header_top_set = -header_menu_top;
          $('header').css({
            'position': 'fixed',
            'top': header_top_set
          });
        } else {
          $('header').css({
            'position': 'absolute',
            'top': 0
          });
        }
      }
      if (!!branches_offset && is_mobile === false && is_iPad === false) {
        scroll_diff_branch_1 = current_top - branch1_offset_top + ($(window).height() / 2);
        scroll_diff_branch_2 = current_top - branch2_offset_top + ($(window).height() / 2);
        scroll_diff_branch_3 = current_top - branch3_offset_top + ($(window).height() / 2);
        scroll_diff_branch_4 = current_top - branch4_offset_top + ($(window).height() / 2);
        if (current_top >= branch1_enter) {
          slide_branch($branch_1, scroll_diff_branch_1, 'left');
        }
        if (current_top >= branch2_enter) {
          slide_branch($branch_2, scroll_diff_branch_2, 'right');
        }
        if (current_top >= branch3_enter) {
          slide_branch($branch_3, scroll_diff_branch_3, 'left');
        }
        if (current_top >= branch4_enter) {
          slide_branch($branch_4, scroll_diff_branch_4, 'right');
        }
        if (scroll_diff_branch_1 > 1) {
          $('#branch_tt_1').stop(true, true).fadeIn();
          $('#branch_tt_1 .branch_dropdown').stop(true, true).slideUp(200);
          $('#branch_tt_2').stop(true, true).fadeIn();
          $('#branch_tt_2 .branch_dropdown').stop(true, true).slideUp(200);
        } else {
          $('#branch_tt_1').stop(true, true).fadeOut();
          $('#branch_tt_2').stop(true, true).fadeOut();
        }
        if (scroll_diff_branch_2 > 1) {
          $('#branch_tt_3').stop(true, true).fadeIn();
          $('#branch_tt_3 .branch_dropdown').stop(true, true).slideUp(200);
        } else {
          $('#branch_tt_3').stop(true, true).fadeOut();
        }
        if (scroll_diff_branch_3 > 1) {
          $('#branch_tt_5').stop(true, true).fadeIn();
          $('#branch_tt_5 .branch_dropdown').stop(true, true).slideUp(200);
        } else {
          $('#branch_tt_5').stop(true, true).fadeOut();
        }
        if (scroll_diff_branch_4 > 1) {
          $('#branch_tt_4').stop(true, true).fadeIn();
          return $('#branch_tt_4 .branch_dropdown').stop(true, true).slideUp(200);
        } else {
          return $('#branch_tt_4').stop(true, true).fadeOut();
        }
      }
    });
    $('.branch_tooltip .branch_dropdown').slideUp(200);
    if (is_mobile === false || is_iPad === false) {
      $('.branch_tooltip').hover(function() {
        return $(this).find('.branch_dropdown').stop(true, true).slideDown(200);
      }, function() {
        return $(this).find('.branch_dropdown').stop(true, true).slideUp(200);
      });
    }
    if (is_iPad === true) {
      $('.branch_tooltip').show();
    }
    if (is_iPad === false) {
      slide_branch = function($branch, scroll_diff, direction) {
        if (scroll_diff < 1) {
          if (direction === 'left') {
            $branch.css({
              'left': scroll_diff
            });
          }
          if (direction === 'right') {
            return $branch.css({
              'right': scroll_diff
            });
          }
        }
      };
    }
    $hiw_sections = $("#hiw_sections");
    $hiw_section_choose = $('#hiw_section_choose');
    $hiw_slider = $("#hiw_slider");
    $hiw_slider_holder = $("#hiw_slider_holder");
    $hiw_header_p = $('#hiw_header p').css({
      top: 40,
      opacity: 0
    });
    slide_bounders = new Array;
    section_number = 1;
    slided_section_width = $hiw_sections.find('section').outerWidth(true);
    mouse_x = 0;
    slide_x = 0;
    set_x = 0;
    x_difference = 0;
    current_x = 0;
    current_x_tip = 0;
    current_x_tip_offset = 0;
    sliding = false;
    $('.step_' + section_number + '_header').animate({
      top: 0,
      opacity: 1
    }, {
      duration: 150,
      easing: 'easeOutBounce',
      queue: true
    });
    $('#hiw_choose_' + section_number).addClass('selected');
    _.each($hiw_section_choose.find('.section_select'), function(key, value) {
      var key_width, section_holder_offset, section_left, section_offset;
      key_width = $(key).outerWidth(true);
      section_offset = $(key).offset();
      section_holder_offset = $hiw_section_choose.offset();
      section_left = section_offset.left - section_holder_offset.left;
      if (is_mobile === false) {
        $hiw_sections.css({
          width: 780 * (value + 1)
        });
      }
      return slide_bounders[value] = {
        left: section_left,
        right: section_left + key_width - 1,
        section_number: value + 1,
        section_left: -(slided_section_width * value)
      };
    });
    $('.section_select').click(function() {
      var current_section, current_section_number;
      current_section_number = $(this).attr('id').split('_')[2];
      current_section = slide_bounders[current_section_number - 1];
      return update_section_selected(current_section);
    });
    adjust_hiw_arrows = function() {
      var hiw_sections_offset;
      if (!!$('#hiw_sections_holder').length) {
        hiw_sections_offset = $('#hiw_sections_holder').offset();
        $('#hiw_left_arrow').css({
          'left': hiw_sections_offset.left - 32
        });
        return $('#hiw_right_arrow').css({
          'left': hiw_sections_offset.left + $('#hiw_sections_holder').width() + 22
        });
      }
    };
    adjust_hiw_arrows();
    $('#hiw_left_arrow').click(function() {
      var current_section;
      section_number--;
      if (section_number < 1) {
        section_number = slide_bounders.length;
      }
      current_section = slide_bounders[section_number - 1];
      return update_section_selected(current_section);
    });
    $('#hiw_right_arrow').click(function() {
      var current_section;
      section_number++;
      if (section_number > slide_bounders.length) {
        section_number = 1;
      }
      current_section = slide_bounders[section_number - 1];
      return update_section_selected(current_section);
    });
    $nickle = $('.nickle').css({
      top: -44
    });
    $donate_amount = $('.donate_amount');
    coin_donation = 0;
    coin_donation_big = 10;
    nickle_fall = function() {
      $nickle.css({
        top: -44
      }).animate({
        top: 161
      }, {
        duration: 1000,
        easing: 'easeOutQuad'
      });
      coin_donation = coin_donation + 5;
      if (coin_donation >= 100) {
        coin_donation = 5;
        coin_donation_big++;
        if (coin_donation_big >= 100) {
          coin_donation_big = 10;
        }
        $donate_amount.find('.amount_big').html(coin_donation_big);
      }
      $donate_amount.find('.amount_nickle').html(coin_donation);
      if (coin_donation === 5) {
        return $donate_amount.find('.amount_nickle').html("0" + coin_donation);
      }
    };
    coin_drop = setInterval(nickle_fall, 3000);
    $('#how_3 .how_3_icon').css({
      top: -180
    });
    go_section_3 = function() {
      return _.each($('#how_3 .how_3_icon'), function(key, value) {
        return $(key).css({
          top: -180
        }).delay(value * 200 + 600).animate({
          top: 35
        }, {
          duration: 800,
          easing: 'easeOutElastic'
        });
      });
    };
    $('#how_4 .check').css({
      width: 0
    });
    go_section_4 = function() {
      return _.each($('#how_4 .check'), function(key, value) {
        return $(key).css({
          width: 0
        }).delay(value * 200 + 1500).animate({
          width: 54
        }, {
          duration: 300,
          easing: 'easeOutSine'
        });
      });
    };
    $(this).mousemove(function(e) {
      return mouse_x = e.pageX;
    });
    $hiw_slider.mousedown(function() {
      var slide_offset;
      slide_offset = $hiw_slider_holder.offset();
      current_x_tip_offset = $hiw_slider_holder.outerWidth(true) / 2;
      slide_x = slide_offset.left;
      set_x = $hiw_slider_holder.outerWidth(true) * (section_number - 1);
      x_difference = mouse_x - slide_x;
      sliding = true;
      return _this.slide_interval = setInterval(update_slide, 5);
    });
    $(this).mouseup(function() {
      return stop_slide();
    });
    update_slide = function() {
      current_x = mouse_x - slide_x - x_difference + set_x;
      if (current_x >= 0 && current_x <= slide_bounders[slide_bounders.length - 1].left) {
        current_x_tip = current_x + current_x_tip_offset;
        return $hiw_slider_holder.stop(true, true).animate({
          left: current_x
        }, {
          duration: 5
        });
      }
    };
    stop_slide = function() {
      var current_section;
      clearInterval(_this.slide_interval);
      if (sliding) {
        sliding = false;
        current_section = _.find(slide_bounders, function(key) {
          return key.left < current_x_tip && key.right > current_x_tip;
        });
        update_section_selected(current_section);
      }
      return sliding = false;
    };
    update_section_selected = function(current_section) {
      var left_slider_offset;
      $hiw_sections.stop(true, true).animate({
        left: current_section.section_left
      }, {
        duration: 800,
        easing: 'easeOutElastic'
      });
      left_slider_offset = current_section.left - $hiw_slider_holder.parent().css('padding-left').replace('px', '');
      $hiw_slider_holder.stop(true, true).animate({
        left: left_slider_offset
      }, {
        duration: 300,
        easing: 'easeOutElastic'
      });
      section_number = current_section.section_number;
      if (current_section.section_number === 3) {
        go_section_3();
      }
      if (current_section.section_number === 4) {
        go_section_4();
      }
      $hiw_header_p.stop(true, true).animate({
        top: 40,
        opacity: 0
      }, {
        duration: 150,
        easing: 'easeOutQuad',
        complete: function() {
          return $('.step_' + section_number + '_header').animate({
            top: 0,
            opacity: 1
          }, {
            duration: 150,
            easing: 'easeOutBounce',
            queue: true
          });
        }
      });
      $hiw_slider.find('p').html(section_number);
      $('.section_select').removeClass('selected');
      return $('#hiw_choose_' + section_number).addClass('selected');
    };
    if (is_mobile === false) {
      $section_contents = $('#section_contents');
      if (is_mobile === false) {
        $section_contents.find('.section_content').css({
          opacity: 0
        });
      }
      if (jQuery.support.opacity === false) {
        $section_contents.find('.section_content_screen').css({
          opacity: 0
        });
      }
      $section_contents.find('#section_content_' + section_number).css({
        opacity: 1
      });
      if (jQuery.support.opacity === false) {
        $section_contents.find('#section_content_' + section_number + ' .section_content_screen').css({
          opacity: 1
        });
      }
      $how_it_works_page_header_text = $('#how_it_works_page .header_text').css({
        top: 40,
        opacity: 0
      });
      $('.lm_step_' + section_number + '_header').animate({
        top: 0,
        opacity: 1
      }, {
        duration: 150,
        easing: 'easeOutBounce',
        queue: true
      });
      section_content_width = $section_contents.find('.section_content').outerWidth(true);
      learn_more_section_length = $section_contents.find('.section_content').length;
      $('#section_left_arrow').click(function() {
        section_number--;
        if (section_number < 1) {
          section_number = learn_more_section_length;
        }
        return learn_more_section_switch();
      });
      $('#section_right_arrow').click(function() {
        section_number++;
        if (section_number > learn_more_section_length) {
          section_number = 1;
        }
        return learn_more_section_switch();
      });
      learn_more_section_switch = function() {
        var new_left;
        new_left = -(section_content_width * (section_number - 1));
        $section_contents.stop(true, true).animate({
          left: new_left
        }, {
          duration: 400,
          easing: 'easeOutBack'
        });
        $section_contents.find('.section_content').stop(true, true).animate({
          opacity: 0
        }, {
          duration: 400,
          easing: 'easeOutQuad'
        });
        if (jQuery.support.opacity === false) {
          $section_contents.find('.section_content_screen').stop(true, true).animate({
            opacity: 0
          }, {
            duration: 400,
            easing: 'easeOutQuad'
          });
        }
        $section_contents.find('#section_content_' + section_number).stop(true, true).animate({
          opacity: 1
        }, {
          duration: 400,
          easing: 'easeOutQuad'
        });
        if (jQuery.support.opacity === false) {
          $section_contents.find('#section_content_' + section_number + ' .section_content_screen').stop(true, true).animate({
            opacity: 1
          }, {
            duration: 400,
            easing: 'easeOutQuad'
          });
        }
        return $how_it_works_page_header_text.stop(true, true).animate({
          top: 40,
          opacity: 0
        }, {
          duration: 150,
          easing: 'easeOutQuad',
          complete: function() {
            return $('.lm_step_' + section_number + '_header').animate({
              top: 0,
              opacity: 1
            }, {
              duration: 150,
              easing: 'easeOutBounce',
              queue: true
            });
          }
        });
      };
    }
    $sign_up_modal = $('#sign_up_modal');
    sign_up_modal_left = ($(window).width() / 2) - ($sign_up_modal.outerWidth(true) / 2);
    $sign_up_modal.css({
      top: -2000,
      left: sign_up_modal_left
    });
    modal_top = 60;
    if (is_mobile === true) {
      modal_top = 20;
    }
    $('.click_sign_up').click(function() {
      $sign_up_modal.stop(true, true).css({
        top: $(window).height(),
        opacity: 1
      }).animate({
        top: modal_top
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
      return false;
    });
    $('.click_hide_sign_up').click(function() {
      $sign_up_modal.stop(true, true).animate({
        top: $(window).height(),
        opacity: 0
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
      return false;
    });
    $create_customer_form = $('#create_customer');
    $create_customer_form.live('submit', function() {
      var create_email, create_family_name, create_first_name, create_is18, create_password;
      create_family_name = $create_customer_form.find('#last_name');
      if (create_family_name.val() === '' || create_family_name.val() === 'Family Name') {
        $create_customer_form.parent().find('.message p').html('Family Name is Required');
        $create_customer_form.parent().find('.message').show().delay(5000).fadeOut();
        create_family_name.focus();
        false;
      }
      create_first_name = $create_customer_form.find('#first_name');
      if (create_first_name.val() === '' || create_first_name.val() === "Family Admin's First Name") {
        $create_customer_form.parent().find('.message p').html('Family Name is Required');
        $create_customer_form.parent().find('.message').show().delay(5000).fadeOut();
        create_first_name.focus();
        false;
      }
      create_email = $create_customer_form.find('#email');
      if (create_email.val() === '' || create_email.val() === 'your@email.com') {
        $create_customer_form.parent().find('.message p').html('Family Name is Required');
        $create_customer_form.parent().find('.message').show().delay(5000).fadeOut();
        create_email.focus();
        false;
      }
      create_password = $create_customer_form.find('#password');
      if (create_password.val() === '' || create_password.val() === 'password') {
        $create_customer_form.parent().find('.message p').html('Password is Required');
        $create_customer_form.parent().find('.message').show().delay(5000).fadeOut();
        create_password.focus();
        false;
      }
      create_is18 = $create_customer_form.find('.over18');
      if (!create_is18.find("input").is(":checked")) {
        $create_customer_form.parent().find('.message p').html('You must be at lease 18 to sign up');
        $create_customer_form.parent().find('.message').show().delay(5000).fadeOut();
        return false;
      }
    });
    $privacy_policies = $("#privacy-policies");
    $page_privacy_policies_modal_close = $(".page-privacy-policies-modal-close");
    $terms_agreement = $("#terms-of-agreement");
    $page_terms_agreement_modal_close = $(".page-terms-agreement-modal-close");
    $privacy_policies.click(function() {
      return $("#page-privacy-policies-modal").css({
        top: $(window).height(),
        opacity: 1,
        display: 'block'
      }).animate({
        top: modal_top
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
    });
    $page_privacy_policies_modal_close.click(function() {
      $("#page-privacy-policies-modal").stop(true, true).animate({
        top: $(window).height(),
        opacity: 0
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
      return false;
    });
    $terms_agreement.click(function() {
      console.log("click");
      return $("#page-terms-agreement-modal").css({
        top: $(window).height(),
        opacity: 1,
        display: 'block'
      }).animate({
        top: modal_top
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
    });
    $page_terms_agreement_modal_close.click(function() {
      $("#page-terms-agreement-modal").stop(true, true).animate({
        top: $(window).height(),
        opacity: 0
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
      return false;
    });
    today = new Date();
    dd = today.getDate();
    mm = today.getMonth() + 1;
    yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    today = mm + '-' + dd + '-' + yyyy;
    console.log('just so you know, today is ' + today);
    $dashboard_header = $('#dashboard_header');
    current_family_id = $(".user_info").attr('id');
    current_customer_json = {};
    children_array = [];
    $update_family_form = $('#customer_info form');
    if (!!current_family_id) {
      customer_url_json = "/community/giving-families/customers/" + current_family_id + ".json";
      $.getJSON(customer_url_json, function(customer) {
        var family_member_check;
        current_customer_json = customer;
        if (!!$update_family_form) {
          if (!!current_customer_json.family_name) {
            $update_family_form.find('[name = "family_name"]').val(current_customer_json.family_name);
          }
          if (!!current_customer_json.father_name) {
            $update_family_form.find('[name = "father_name"]').val(current_customer_json.father_name);
          }
          if (!!current_customer_json.father_birthdate) {
            $update_family_form.find('[name = "father_birthdate"]').val(current_customer_json.father_birthdate);
          }
          if (!!current_customer_json.mother_name) {
            $update_family_form.find('[name = "mother_name"]').val(current_customer_json.mother_name);
          }
          if (!!current_customer_json.mother_birthdate) {
            $update_family_form.find('[name = "mother_birthdate"]').val(current_customer_json.mother_birthdate);
          }
          if (!!current_customer_json.more_info) {
            $update_family_form.find('[name = "more_info"]').val(current_customer_json.more_info);
          }
          _.each(current_customer_json.children, function(value, key) {
            children_array.push(value);
            $update_family_form.find('#child_' + (key + 1) + ' .child_name').val(value.name);
            $update_family_form.find('#child_' + (key + 1) + ' .child_id').val(value.id);
            $update_family_form.find('#child_' + (key + 1) + ' .birthday').val(value.birthdate);
            if (current_customer_json.children.length > key + 1) {
              return $('#child_' + (key + 1) + ' .add_child_input').click();
            }
          });
        }
        if (current_customer_json.shopify_customer_id !== 0 && !current_customer_json.family_name && window.location.pathname !== '/account/addresses') {
          $.removeCookie("family_member");
          $('#signing_in_extras').fadeIn();
        }
        show_credits_dashboard(Math.round(current_customer_json.credits));
        add_family_member_to_select();
        if (!!$.cookie('family_member')) {
          update_user_dashboard($.cookie('family_member'));
          if ($.cookie('family_member') !== current_customer_json.father_name && $.cookie('family_member') !== current_customer_json.mother_name) {
            family_member_check = _.find(children_array, function(child) {
              return child.name.split(' ')[0] === $.cookie('family_member');
            });
            if (!family_member_check) {
              show_family_member_switcher(false);
            }
          }
        } else {
          if (!!current_customer_json.family_name) {
            show_family_member_switcher(false);
          }
        }
        return update_giving_history(current_customer_json);
      });
    }
    $('.user_info h3 span').live('click', function() {
      return show_family_member_switcher(true);
    });
    $('#logging_in_extras .extras_close').live('click', function() {
      return $(this).parent().parent().fadeOut();
    });
    $('#logging_in_extras #which_family_member').live('submit', function() {
      $.cookie("family_member", $('.family_member_using').val(), {
        expires: 30,
        path: '/'
      });
      $(this).parent().parent().fadeOut();
      update_user_dashboard($.cookie('family_member'));
      return false;
    });
    show_family_member_switcher = function(show_close) {
      $('#logging_in_extras').fadeIn();
      if (show_close === false) {
        $('#logging_in_extras .extras_close').hide();
        return $.removeCookie("family_member");
      } else {
        return $('#logging_in_extras .extras_close').show();
      }
    };
    add_family_member_to_select = function() {
      $('#which_family_member select').append("<option value=" + current_customer_json.father_name + ">" + current_customer_json.father_name + " (dad)</option>");
      $('#which_family_member select').append("<option value=" + current_customer_json.mother_name + ">" + current_customer_json.mother_name + " (mom)</option>");
      return _.each(children_array, function(value) {
        return $('#which_family_member select').append("<option value=" + value.name + ">" + value.name + "</option>");
      });
    };
    update_user_dashboard = function(family_mem) {
      return $dashboard_header.find('.user_info h3').html(family_mem + ' ' + current_customer_json.family_name + ' <span>(switch user)</span>');
    };
    show_credits_dashboard = function(credits) {
      var show_credits, user_credits_split;
      user_credits_split = String(credits).split('');
      show_credits = "";
      _.each(user_credits_split, function(val) {
        return show_credits += "<div class='credit_numeral'><p>" + val + "</p></div>";
      });
      $dashboard_header.find('.credit_amount').css('width', 44 * user_credits_split.length + 30);
      return $dashboard_header.find('.credit_amount').html(show_credits);
    };
    number_of_children = 1;
    $(this).on('click', '.add_child_input', function() {
      var family_member_row_html;
      number_of_children++;
      family_member_row_html = "<div class=\"family_member_row new_child child\" id=\"child_" + number_of_children + "\">\n  <div class=\"form-row clearfix\">\n    <label>Child</label>\n    <input type=\"hidden\" class=\"child_id\" name=\"child_id\" value=\"\">\n    <input type=\"text\" class=\"input child_name\">\n    <div class=\"remove_child_input\"></div>\n    <div class=\"add_child_input\"></div>\n  </div>\n  <div class=\"form-row clearfix\">\n    <label>Birthday</label>\n    <input type=\"text\" class=\"input birthday\" placeholder=\"xx-xx-xxxx\">\n  </div>\n</div>";
      $(this).parent().parent().after(family_member_row_html);
      $(this).parent().find('.remove_child_input').remove();
      $(this).removeClass('add_child_input');
      return $(this).addClass('remove_child_input');
    });
    children_to_remove = [];
    $('.remove_child_input').live('click', function() {
      number_of_children--;
      if ($(this).parent().find('.child_id').val() !== '') {
        children_to_remove.push($(this).parent().find('.child_id').val());
      }
      if ($(this).parent().parent().attr('id') === 'child_' + (number_of_children + 1)) {
        $(this).parent().parent().prev().find('.remove_child_input').parent().append('<div class="add_child_input"></div>');
      }
      if (number_of_children === 1) {
        $(this).parent().parent().prev().find('.remove_child_input').remove();
      }
      $(this).parent().parent().remove();
      return adjust_child_form_ids();
    });
    adjust_child_form_ids = function() {
      _.each($('.child'), function(value, key) {
        return $(value).attr('id', 'child_' + (key + 1));
      });
      if (number_of_children === 1) {
        return $('.remove_child_input').remove();
      }
    };
    birthday_length_check = 0;
    $('#customer_info').on('keyup', 'input.birthday', function() {
      var new_val;
      if ($(this).val().length === 2 || $(this).val().length === 5) {
        if (birthday_length_check < $(this).val().length) {
          new_val = $(this).val() + "-";
          $(this).val(new_val);
          return birthday_length_check = new_val.length;
        } else {
          return birthday_length_check = 0;
        }
      }
    });
    family_ajax_data = {};
    $update_family_form.find('#customer_info_submit').live('click', function() {
      var customer_family_ajax_data;
      family_ajax_data.family_name = $update_family_form.find('[name = "family_name"]').val();
      family_ajax_data.father_name = $update_family_form.find('[name = "father_name"]').val();
      family_ajax_data.father_birthdate = $update_family_form.find('[name = "father_birthdate"]').val();
      family_ajax_data.mother_name = $update_family_form.find('[name = "mother_name"]').val();
      family_ajax_data.mother_birthdate = $update_family_form.find('[name = "mother_birthdate"]').val();
      family_ajax_data.more_info = $update_family_form.find('[name = "more_info"]').val();
      _.each($update_family_form.find('.child'), function(key, value) {
        var child_birthday, child_name, child_to_update;
        child_name = $('#child_' + (value + 1) + ' .child_name').val();
        child_birthday = $('#child_' + (value + 1) + ' .birthday').val();
        if (!$('#child_' + (value + 1) + ' .child_id').val()) {
          if (!!child_name) {
            return children_array.push({
              name: child_name,
              birthdate: child_birthday
            });
          }
        } else {
          child_to_update = _.find(children_array, function(child) {
            return child.id === parseInt($('#child_' + (value + 1) + ' .child_id').val());
          });
          child_to_update.name = child_name;
          return child_to_update.birthdate = child_birthday;
        }
      });
      _.each(children_to_remove, function(value) {
        var child_to_remove;
        child_to_remove = _.find(children_array, function(child) {
          return child.id === parseInt(value);
        });
        return child_to_remove._destroy = true;
      });
      customer_family_ajax_data = {
        customer: family_ajax_data
      };
      customer_family_ajax_data.customer.children_attributes = children_array;
      $.ajax({
        url: '/community/giving-families/customers/' + current_family_id + '.json',
        type: 'PUT',
        dataType: 'JSON',
        data: customer_family_ajax_data,
        error: function(x, s, e) {
          $update_family_form.find('.error p').html('An error occured, please try again later');
          return $update_family_form.find('.error').show().delay(5000).fadeOut();
        },
        success: function(customer) {
          return $update_family_form.find('.success').show().delay(5000).fadeOut();
        },
        complete: function() {
          return $('html,body').animate({
            scrollTop: 100
          }, {
            duration: 400,
            easing: 'easeOutQuad'
          });
        }
      });
      return false;
    });
    json_data_charities = {};
    charities_for_voting = [];
    current_selected_charity = '';
    preloaded_images = new Array;
    get_charity_category_json = function() {
      return $.getJSON('/community/giving-families/categories.json', function(data) {
        json_data_charities = data;
        _.each(json_data_charities, function(key, value) {
          var keyname, no_the_keyname, slug;
          key.charities;
          keyname = key.name;
          slug = keyname.replace(" ", '_');
          key.thumb = key.asset_url;
          preloaded_images = $("<img>").attr('src', key.thumb);
          no_the_keyname = keyname.split(' ')[1];
          if (!no_the_keyname) {
            no_the_keyname = keyname;
          }
          charities_html_list += "<div class=\"dashboard_charity_choose\" id=\"id_" + value + "\">\n  <div class=\"dashboard_charity_choose_avatar choose_" + keyname + "_avatar\">\n    <img src=\"" + key.thumb + "\">\n  </div>\n  <p><span class=\"help-the\">Help The <br> </span>" + no_the_keyname + "</p>\n</div>";
          _.each(key.charities, function(key, value) {
            if (key.donated_amount === null) {
              return key.donated_amount = 0;
            }
          });
          key.charity_for_category = _.find(key.charities, function(charity) {
            return charity.featured === true;
          });
          if (!key.charity_for_category) {
            return key.charity_for_category = key.charities[0];
          }
        });
        return $dashboard_charity_chooser.empty().append(charities_html_list);
      });
    };
    if (window.location.pathname === '/account') {
      get_charity_category_json();
    }
    $dashboard_charity_chooser = $('.featured_charity_donate .dashboard_charity_chooser');
    $dashboard_single_charity_view = $('.featured_charity_donate .dashboard_single_charity_view');
    $dashboard_single_charity_header = $dashboard_single_charity_view.find('.dashboard_single_charity_header');
    $dashboard_single_charity_info = $dashboard_single_charity_view.find('.dashboard_single_charity_info');
    $charity_sponsor = $('.charity_sponsor');
    $single_donate_goal_meter = $('.single_donate_goal_meter');
    charities_html_list = '';
    charity_for_category = new Object;
    charity_showing = false;
    $('.dashboard_charity_choose').live('click', function() {
      dashboard_show_charity($(this).attr('id').split('_')[1]);
      if (charity_showing === true) {
        $('html,body').animate({
          scrollTop: 0
        }, {
          duration: 400,
          easing: 'easeOutQuad'
        });
      }
      return charity_showing = true;
    });
    dashboard_show_charity = function(charity_category_key) {
      var current_selected_charity_sponsor, no_the_name;
      $('.dashboard_single_charity_view').slideDown();
      $('.single_donate_goal_meter').delay(400).animate({
        left: 636,
        opacity: 1
      }, {
        duration: 400,
        easing: 'easeOutQuad'
      });
      current_selected_charity = json_data_charities[charity_category_key].charity_for_category;
      $dashboard_single_charity_header.find('img').attr('src', json_data_charities[charity_category_key].thumb);
      no_the_name = json_data_charities[charity_category_key].name.split(' ')[1];
      if (!no_the_name) {
        no_the_name = json_data_charities[charity_category_key].name;
      }
      if (no_the_name === "Featured") {
        $dashboard_single_charity_header.find('h2').html(no_the_name);
      } else {
        $dashboard_single_charity_header.find('h2').html('Help The' + no_the_name);
      }
      $('.dashboard_single_charity_logo').attr('src', '#');
      $('.dashboard_single_charity_logo').attr('src', current_selected_charity.asset_url);
      if (!current_selected_charity.asset_url) {
        $dashboard_single_charity_info.find('h3').html(current_selected_charity.name);
      } else {
        $dashboard_single_charity_info.find('h3').hide();
      }
      console.log(current_selected_charity.expires, 'days to expire', current_selected_charity);
      $dashboard_single_charity_info.find('h4 span').html(current_selected_charity.expires + ' days');
      if (current_selected_charity.expires === 1) {
        $dashboard_single_charity_info.find('h4 span').html(current_selected_charity.expires + ' day');
      }
      $dashboard_single_charity_info.find('p').html(current_selected_charity.description);
      $dashboard_single_charity_info.find('.button').attr('href', current_selected_charity.website);
      if (current_selected_charity.sponsor === null) {
        $('.charity_sponsor_title').css({
          opacity: 0
        });
        $charity_sponsor.css({
          opacity: 0
        });
        $charity_sponsor.find('.charity_sponsor_img').css({
          opacity: 0
        });
        $charity_sponsor.find('h4').html('');
        $charity_sponsor.find('p').html('');
        $charity_sponsor.find('a').attr('href', '');
        $charity_sponsor.find('a').html('');
      } else {
        $('.charity_sponsor_title').css({
          opacity: 1
        });
        current_selected_charity_sponsor = current_selected_charity.sponsor;
        $charity_sponsor.css({
          opacity: 1
        });
        $charity_sponsor.find('.charity_sponsor_img').css({
          opacity: 1
        }).html('<img src="' + current_selected_charity_sponsor.asset_url + '" >');
        $charity_sponsor.find('h4').html(current_selected_charity_sponsor.name);
        $charity_sponsor.find('p').html(current_selected_charity_sponsor.description);
        $charity_sponsor.find('a').attr('href', current_selected_charity_sponsor.website);
        $charity_sponsor.find('a').html(current_selected_charity_sponsor.website);
      }
      return adjust_goal_meter(current_selected_charity.goal_amount.split('.')[0], parseInt(current_selected_charity.donated_amount), current_selected_charity.goal_amount);
    };
    go_current_goal_percent = function(percent_of, percent_max) {
      return Math.round(100 * (percent_of / percent_max));
    };
    adjust_goal_meter = function(goal_amount, donated_amount, percent_max) {
      var current_goal_percent, current_goal_position, difference_for_percent;
      $single_donate_goal_meter.find('.goal_level_top').html('$' + goal_amount);
      $single_donate_goal_meter.find('.goal_level_indicator span').html("$" + donated_amount);
      current_goal_percent = go_current_goal_percent(donated_amount, percent_max);
      difference_for_percent = 274 - 28;
      current_goal_position = Math.round((current_goal_percent / 100) * difference_for_percent + 28);
      return $single_donate_goal_meter.find('.goal_level_indicator').css('bottom', current_goal_position);
    };
    donate_to_charity = function(donate_amount) {
      $(".dashboard_single_donate form .input").val('0');
      console.log('donate ' + donate_amount + ' credits to ' + current_selected_charity.name + ' at id ' + current_selected_charity.id + ' from : id = ' + current_customer_json.shopify_customer_id + ' made by family member: ' + $.cookie('family_member'));
      return $.ajax({
        url: '/community/giving-families/charities/' + current_selected_charity.id + '/donate.json',
        type: 'POST',
        dataType: 'JSON',
        data: {
          amount: donate_amount,
          customer_id: current_customer_json.shopify_customer_id,
          name: $.cookie('family_member')
        },
        error: function(x, s, e) {
          return console.log([x, s, e]);
        },
        success: function() {
          console.log('donation successful');
          return show_credits_dashboard(current_customer_json.credits - donate_amount);
        },
        complete: function() {
          var charity_category_asset;
          console.log('donation complete, dashboard updated');
          current_customer_json.credits = current_customer_json.credits - donate_amount;
          show_credits_dashboard(current_customer_json.credits);
          current_selected_charity.donated_amount = parseInt(current_selected_charity.donated_amount) + parseInt(donate_amount);
          adjust_goal_meter(current_selected_charity.goal_amount.split('.')[0], current_selected_charity.donated_amount, current_selected_charity.goal_amount);
          charity_category_asset = _.find(json_data_charities, function(charity) {
            return charity.id === current_selected_charity.category_id;
          });
          charity_category_asset = charity_category_asset.asset_url;
          $('#dashboard_giving_history tbody').prepend(add_giving_history_line(current_selected_charity, current_customer_json, current_selected_charity.name, charity_category_asset, $.cookie('family_member'), today, donate_amount));
          return $('.confirm_donate').fadeIn();
        }
      });
    };
    $(".dashboard_single_donate form .input").numeric();
    $(this).on('submit', '.dashboard_single_donate form', function() {
      var $donate_message, donate_input_value, form_position;
      $donate_message = $(this).find('.message');
      $donate_message.fadeOut();
      form_position = $(this).position();
      $donate_message.css({
        top: form_position.top + 87
      });
      $('.confirm_donate').css({
        top: form_position.top + 12
      });
      donate_input_value = parseInt($(".dashboard_single_donate form .input").val());
      if (donate_input_value > 0) {
        if (donate_input_value > current_customer_json.credits) {
          $donate_message.find('p').html('You have ' + current_customer_json.credits.split('.')[0] + ' credits<br>purchase more <a href="/products/credits">here</a>');
          $donate_message.fadeIn();
          false;
        }
        if (donate_input_value <= current_customer_json.credits) {
          donate_to_charity(donate_input_value);
        }
      } else {
        $donate_message.find('p').html('Insert credit amount');
        $donate_message.fadeIn().delay(5000).fadeOut();
      }
      return false;
    });
    $('.confirm_donate').on('click', 'a', function() {
      return $(this).parent().parent().fadeOut();
    });
    $dashboard_single_charity_header.on('click', '.close', function() {
      $('.dashboard_single_charity_view').delay(200).slideUp();
      $('.single_donate_goal_meter').animate({
        left: 500,
        opacity: 0
      }, {
        duration: 200,
        easing: 'easeOutQuad'
      });
      return charity_showing = false;
    });
    update_giving_history = function(family_json) {
      var add_to_table;
      add_to_table = '';
      _.each(family_json.donations.reverse(), function(key, value) {
        var donation_date;
        donation_date = date_fixer(key.created_at);
        return add_to_table += add_giving_history_line(key, family_json, key.charity.name, key.charity.category.asset_url, key.name, date_fixer(key.created_at), Math.round(key.amount));
      });
      return $('#dashboard_giving_history tbody').append(add_to_table);
    };
    add_giving_history_line = function(line_info, family_info, charity_name, category_image, donater, the_donation_date, this_donated_amount) {
      var new_history_line;
      new_history_line = "<tr>\n    <td class=\"history_category\"><img src=\"" + category_image + "\" width=\"60\" height=\"60\"></td>\n    <td class=\"history_charity\">" + charity_name + "</td>\n    <td class=\"history_user\">" + donater + "</td>\n    <td class=\"history_date\">" + the_donation_date + "</td>\n    <td class=\"history_amount\">" + this_donated_amount + " credits</td>\n</tr>";
      return new_history_line;
    };
    date_fixer = function(the_date_to_fix) {
      var date_fix_array, new_date;
      date_fix_array = the_date_to_fix.split('T')[0].split('-');
      new_date = date_fix_array[1] + '-' + date_fix_array[2] + '-' + date_fix_array[0];
      return new_date;
    };
    $all_suggest_boxes = $('.suggest_charity');
    $suggest_charity_button = $all_suggest_boxes.find('.button');
    form_url = 'http://getsimpleform.com/messages?form_api_token=72d8f4d7bf4a96af61cf29ee7ddf4040';
    $suggest_charity_button.live('click', function() {
      var charity_name, charity_website, customer_name, suggest_Message;
      $all_suggest_boxes.find('.error').hide();
      $all_suggest_boxes.find('.ajax_loader').fadeIn();
      charity_name = $all_suggest_boxes.find('#charity_name').val();
      if (charity_name === '' || charity_name === 'Charity Name') {
        $all_suggest_boxes.find('.error p').html('Charity Name Required');
        $all_suggest_boxes.find('.error').show().delay(5000).fadeOut();
        $all_suggest_boxes.find('input#charity_name').focus();
        $all_suggest_boxes.find('.ajax_loader').fadeOut();
        return false;
      }
      charity_website = $all_suggest_boxes.find('#charity_website').val();
      if (charity_website === '' || charity_website === 'Charity Website') {
        $all_suggest_boxes.find('.error p').html('Charity Website Required');
        $all_suggest_boxes.find('.error').show().delay(5000).fadeOut();
        $all_suggest_boxes.find('input#charity_website').focus();
        $all_suggest_boxes.find('.ajax_loader').fadeOut();
        return false;
      }
      suggest_Message = $all_suggest_boxes.find('#suggest_Message').val();
      if (suggest_Message === '' || suggest_Message === 'Make Your Case') {
        $all_suggest_boxes.find('.error p').html('Message Required');
        $all_suggest_boxes.find('.error').show().delay(5000).fadeOut();
        $all_suggest_boxes.find('#suggest_Message').focus();
        $all_suggest_boxes.find('.ajax_loader').fadeOut();
        return false;
      }
      customer_name = $all_suggest_boxes.find('#customer_name').val();
      $all_suggest_boxes.find('#suggest_Message').val('');
      $.ajax({
        type: 'POST',
        url: form_url,
        data: {
          form: 'Suggested Charity',
          user_name: customer_name,
          charity_name: charity_name,
          charity_website: charity_website,
          suggest_message: suggest_Message
        },
        complete: function() {
          $all_suggest_boxes.find('.success').show().delay(5000).fadeOut();
          return $all_suggest_boxes.find('.ajax_loader').fadeOut();
        }
      });
      return false;
    });
    $share_story = $('.share_story_form');
    $share_story_button = $share_story.find('.button');
    $share_story_button.live('click', function() {
      var share_email, share_name, share_story;
      $share_story.find('.error').hide();
      $share_story.find('.ajax_loader').fadeIn();
      share_name = $share_story.find('#share_name').val();
      if (share_name === '') {
        $share_story.find('.error p').html('Name Required');
        $share_story.find('.error').show().delay(5000).fadeOut();
        $share_story.find('input#share_name').focus();
        $share_story.find('.ajax_loader').fadeOut();
        return false;
      }
      share_email = $share_story.find('#share_email').val();
      if (share_email === '') {
        $share_story.find('.error p').html('Email Required');
        $share_story.find('.error').show().delay(5000).fadeOut();
        $share_story.find('input#share_email').focus();
        $share_story.find('.ajax_loader').fadeOut();
        return false;
      }
      share_story = $share_story.find('#share_story').val();
      if (share_story === '' || share_story === 'Your Story') {
        $share_story.find('.error p').html('Story Required');
        $share_story.find('.error').show().delay(5000).fadeOut();
        $share_story.find('#share_story').focus();
        $share_story.find('.ajax_loader').fadeOut();
        return false;
      }
      $.ajax({
        type: 'POST',
        url: form_url,
        data: {
          form: 'Shared Story',
          name: share_name,
          email: share_email,
          story: share_story
        },
        complete: function() {
          $share_story.find('.success').show().delay(5000).fadeOut();
          $share_story.find('.ajax_loader').fadeOut();
          return $share_story.find('#share_story').val('');
        }
      });
      return false;
    });
    $suggest_box = $('.vote .suggest_charity');
    suggest_box_left = ($(this).width() - $('.vote_content').width()) / 2 - 5;
    $suggest_box.css({
      left: suggest_box_left
    });
    $('.vote .suggest').click(function() {
      return $suggest_box.slideDown();
    });
    $suggest_box.find('h3').click(function() {
      return $suggest_box.slideUp();
    });
    $vote_content = $('.vote_content');
    voting_charities_html = "";
    json_data_voting = {};
    $.getJSON('/community/giving-families/categories.json', function(data) {
      var json_data_these_charities;
      json_data_these_charities = data;
      return $.getJSON('/community/giving-families/charities.json', function(data) {
        json_data_voting = data;
        _.each(json_data_voting, function(key, value) {
          var votable_category;
          if (key.votable === true && key.id !== 1) {
            votable_category = _.find(json_data_these_charities, function(categories) {
              return categories.id === key.category_id;
            });
            return voting_charities_html += "<div class=\"vote_charity\">\n  <input type=\"radio\" name=\"voted\" value=\"" + key.id + "\" class=\"vote_checkbox\">\n  <img src=\"" + votable_category.asset_url + "\">\n  <span class=\"side_cat_name\">" + votable_category.name + "</span>\n  <div class=\"vote_charity_info\">\n    <h4>" + key.name + "</h4>\n    <h5>" + key.votes + " votes</h5>\n    <p>" + key.description + "</p>\n  </div>\n</div>";
          }
        });
        voting_charities_html += "<input type=\"submit\" class=\"button medium_btn\" value=\"Submit Your Vote\">";
        $('#voting_form').append(voting_charities_html);
        return $('.vote_charity').on('mouseover', 'img', function() {
          return $(this).next().fadeIn();
        }).on('mouseout', 'img', function() {
          return $(this).next().fadeOut();
        });
      });
    });
    $vote_content.on('click', '.button', function() {
      var voted_for;
      if (parseInt($.cookie('voted')) < 5 || $.cookie('voted') === null) {
        voted_for = $vote_content.find('input:checked').val();
        if (voted_for === void 0) {
          $vote_content.find('.error').show().delay(5000).fadeOut();
          $('html,body').animate({
            scrollTop: 0
          }, {
            duration: 400,
            easing: 'easeOutQuad'
          });
          false;
        }
        $.ajax({
          type: 'POST',
          url: '/community/giving-families/charities/' + voted_for + '/vote.json',
          dataType: 'json',
          success: function() {
            var number_voted;
            number_voted = parseInt($.cookie('voted')) + 1;
            if ($.cookie('voted') === null) {
              number_voted = 1;
            }
            console.log(number_voted, 'number voted');
            $.cookie("voted", number_voted, {
              expires: 30
            });
            console.log($.cookie('voted'), 'cookie voted');
            $vote_content.find('.success').show().delay(5000).fadeOut();
            return $('html,body').animate({
              scrollTop: 0
            }, {
              duration: 400,
              easing: 'easeOutQuad'
            });
          }
        });
      } else {
        $vote_content.find('.voted').show().delay(5000).fadeOut();
        $('html,body').animate({
          scrollTop: 0
        }, {
          duration: 400,
          easing: 'easeOutQuad'
        });
      }
      return false;
    });
    _.each($('#cart_table tr'), function(value, key) {
      if ($(value).find('.cart_product_description h4 a').text().split(' ')[0] === 'Credits') {
        $(value).find('.qty input').css({
          'background': 'white'
        });
        $(value).find('.qty input').attr('readonly', true);
        $(value).find('.qty input').attr('value', 1);
        if ($(value).find('.qty').attr('id').split('_')[1] !== '1') {
          return $('#update-cart').click();
        }
      }
    });
    $(this).on('submit', '#product_page', function() {
      var recipient_email_value;
      recipient_email_value = $("#recipient_email").val();
      if (recipient_email_value === '') {
        $('#product_page .message').fadeIn().delay(5000).fadeOut();
        return false;
      }
    });
    $all_charities = $('#all_charities');
    charities_categories_html = '';
    return $.getJSON('/community/giving-families/categories.json', function(data) {
      var json_data_charities_categories;
      json_data_charities_categories = data;
      _.each(json_data_charities_categories, function(value, key) {
        charities_categories_html += "<div class=\"charity_category\">\n  <h4>" + value.name + "</h4>";
        return _.each(value.charities, function(value) {
          return charities_categories_html += "<div class=\"single_charity\" id=\"" + value.id + "\">\n  <h5>" + value.name + "</h5>\n    <form>\n      <div class=\"message\"><p></p></div>\n      <input type=\"text\" class=\"input\" value=\"0\">\n      <input type='submit' class=\"button\" value=\"donate\">\n    </form> \n</div>";
        });
      });
      charities_categories_html += "        \n</div>";
      return $all_charities.append(charities_categories_html);
    });
  });

}).call(this);
